var _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pv92s1iz3a",
    x: 0,
    y: 0,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 875"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#pv92s1iz3a)"
    },
    "data-name": "Group 679"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 93",
    width: 32,
    height: 32,
    rx: 16,
    transform: "translate(7.496 5.496)",
    style: {
      fill: "#faa100"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m80.934 13.49 1.621-1.621v6.71a.548.548 0 0 0 1.1 0V11.87l1.615 1.62a.548.548 0 0 0 .774-.774l-2.555-2.556q-.019-.019-.04-.036l-.019-.014-.024-.018-.023-.014-.023-.013-.024-.012-.024-.011-.024-.009-.027-.009-.024-.006-.028-.007h-.213l-.027.007-.025.006-.026.009-.025.009-.024.011-.025.012-.022.013-.024.015-.023.017-.02.015c-.013.011-.026.022-.038.035l-2.556 2.556a.548.548 0 0 0 .774.774z",
    transform: "translate(-59.602 4.476)",
    style: {
      fill: "#fff",
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 160a.548.548 0 0 0-.548.548v4.2H1.1v-4.2a.548.548 0 1 0-1.1 0v4.746a.548.548 0 0 0 .548.548H11.5a.548.548 0 0 0 .548-.548v-4.746A.548.548 0 0 0 11.5 160z",
    transform: "translate(17.476 -137.318)",
    style: {
      fill: "#fff",
      stroke: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.8c51099ac4a5b5db62a18db43ae9db07.svg";
export { ForwardRef as ReactComponent };